import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { mapActions } from 'vuex';
import { createEventBus, getDispatchData, removeEventBus } from '@appbase/util/eventBus'
import modalHelper from '@appbase/util/modal-helper';

import { TWishContainerValueType } from '@orgmap/types/enums'
import OrgModalView from '@orgmap/views/OrgmapModalView.vue'
import GradeSelectModal from '@survey/components/Common/GradeSelectModal.vue';
import CompanySelectModal from '@survey/components/Common/CompanySelectModal.vue';

export interface TWishContainerOptionItem {
    id: number
    name: string
    height: string
    items? : orgmap.TWishContainerItem[]
}

export interface TWishContainerOptions {
    addableDept: boolean,
    containers: TWishContainerOptionItem[]
}

export interface TWishItemPropsOptions {
    props: string[]
}

const EVENT_ORG_POPUP = '$survey/org/popup'
const EVENT_GRD_POPUP = '$survey/org/gradePopup'
const EVENT_COM_POPUP = '$survey/org/companyPopup'

@Component({
})

export default class SurveyTargetContainer extends Vue {
    @Prop({ default: [], type: Array }) users!: Array<survey.SurveyTargets>
    
    created() {
        createEventBus(window, EVENT_ORG_POPUP, this.handlePopupResult);
        createEventBus(window, EVENT_GRD_POPUP, this.handleGradeResult);
        createEventBus(window, EVENT_COM_POPUP, this.handleCompanyResult);
    }

    beforeDestroy() {
        removeEventBus(window, EVENT_ORG_POPUP, this.handlePopupResult);
        removeEventBus(window, EVENT_GRD_POPUP, this.handleGradeResult);
        removeEventBus(window, EVENT_COM_POPUP, this.handleCompanyResult);

        modalHelper.close();
    }

    getDisplayName(data : survey.SurveyTargets){
        if(data.isDepartment || data.isGrade){
            return data.displayName
        } else {
            return `${data.displayName} (${data.deptName})`
        }
    }

    remove(identityCode: string) {
        this.$emit("delete", identityCode)
    }

    //회사별 조회 팝업
    openCompany() {
        modalHelper.show({ component: CompanySelectModal, value: { eventname: EVENT_COM_POPUP } })
    }

    openGrade() {
        modalHelper.show({ component: GradeSelectModal, value: { eventname: EVENT_GRD_POPUP } })
    }

    openOrg() {
        const options: TWishContainerOptions = {        
            addableDept: true,
            containers: [
                {
                    id: 0,
                    name: this.$t('대상').toString(),
                    height: '1',
                    items: this.users.map((item:any) =>{
                        return{
                            text: "",
                            value: item.id,
                            valueType : item.isDepartment ? TWishContainerValueType.deptCode : TWishContainerValueType.personCode,
                            selected: false
                        } as orgmap.TWishContainerItem

                    })
                }
            ]
        }

        const props: TWishItemPropsOptions = {
            props: ['id', 'name', 'personCode', 'deptName','deptCode'],
        }

        modalHelper.show({
            component: OrgModalView, force: true, value: {
                options: options,
                props: props,
                event: EVENT_ORG_POPUP
            }
        });
    }

    // 회사별 선택 callback
    handleCompanyResult(company: survey.Company[]) {
        var returnData: survey.SurveyTargets[] = company.map(c => <survey.SurveyTargets>{
            identityCode: c.comCode,
            isGrade: false,
            isCompany: true,
            isDepartment: false,
            displayName: c.companyName,
            deptName: ''
        });

        this.$emit('update', returnData);
    }

    handleGradeResult(grades: survey.OrgGrade[]) {
        var returnData: survey.SurveyTargets[] = grades.map(g => <survey.SurveyTargets>{
            identityCode: g.gradeCode,
            isGrade: true,
            isCompany: false,
            isDepartment: false,
            displayName: g.gradeName,
            deptName: ''
        });

        this.$emit('update', returnData);
    }

    handlePopupResult() {       
        const result = getDispatchData(EVENT_ORG_POPUP) || {}
        console.log('result', result);

        if (result[0].items.length > 0) {
           
            // this.users = result[0].items
            let containerData = result[0].items.map((data : any) => {
                if (data.personCode && data.personCode != "") {
                    return <survey.SurveyTargets>{
                        identityCode: data.personCode,
                        isGrade: false,
                        isCompany: false,
                        isDepartment: false,
                        deptName: data.deptName,
                        displayName : data.text      
                    }
                } else {
                    return <survey.SurveyTargets>{
                        identityCode: data.id,
                        isGrade: false,
                        isCompany: false,
                        isDepartment: true,
                        deptName : data.deptName,
                        displayName: data.deptName
                    }
                }
            })
 
            console.log('containerData', containerData);
            this.$emit('update', containerData)
        }
    }

    async onDeleteAll() {
        if(await (window as any).confirmAsync(this.$t('M_Contact_DeleteAll').toString())){
            this.$emit('deleteall');
        }
    }
}
